import applyMiddleware from '../../utils/route/applyMiddleware';
import requireRole from '../../utils/route/requireRole';
import Roles from '../../constants/Roles';
import PublishMain from './components/PublishMain';

const bankApp = {
  name: 'publish',
  path: 'publish',
  onEnter: applyMiddleware(requireRole(Roles.PUBLISHING)),
  component: PublishMain
};

export default bankApp;



// WEBPACK FOOTER //
// ./src/apps/Publish/index.js